// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__1RWDq","messages":"Chat_messages__3UTGt","dateDivider":"Chat_dateDivider__3qOhO"};